export enum SharedWorkerMessage {
  StartAssignMasterTab = 'StartAssignMasterTab',
  ShiftMasterTab = 'ShiftMasterTab',

  UserLogout = 'UserLogout',

  SendFeKey = 'SendFeKey',
  AddToWaitingList = 'AddToWaitingList',

  BroadcastChangesToTabs = 'BroadcastChangesToTabs',

  // SendManualModeChanges = 'SendSyncManualModeChanges',

  SyncManualSaveToggle = 'SyncManualSaveToggle',


  SyncManualModeAfterChangesSaved = "SyncManualModeAfterChangesSaved",
  SyncManualModeAfterChangesDiscard = "SyncManualModeAfterChangesDiscard"
}

export enum SharedWorkerResponse {
  SetAsMasterTab = 'SetAsMasterTab',
  ForceLogout = 'ForceLogout',

  RequestFeKey = 'RequestFeKey',
  ReceivePassKey = 'ReceivePassKey',

  MasterTabConflict = 'MasterTabConflict',
  MasterTabConflictResolved = 'MasterTabConflictResolved',

  ReceiveNotifiedChanges = 'ReceiveNotifiedChanges',

  ReceiveManualModeChanges = 'ReceiveManualModeChanges',

  UpdateManualSaveToggle = 'UpdateManualSaveToggle',

  ReceiveManualModeAfterChangesSaved = "ReceiveManualModeAfterChangesSaved",
  ReceiveManualModeAfterChangesDiscard = "ReceiveManualModeAfterChangesDiscard"

  // AddWALInMem = "AddWALInMem",
}
